function initSocialShare() {
    $(".share-icon").click(function() {
       let target = $(this).data("target");
       $(target).toggleClass("share-buttons-show");
    });
}